import { TextField } from 'unform-material-ui';

export default (props) => (
  <TextField {...props} color="secondary" />
);
